<div class="otp-inputs">
    <input
        *ngFor="let i of otpFields"
        type="text"
        maxlength="1"
        class="otp-inputs__field"
        #otpInput
        pattern="[0-9]*"
        inputmode="numeric"
        (input)="onInput($event, i)"
        (keydown)="onKeydown($event, i)"
        (paste)="onPaste($event)"
        autocomplete="one-time-code"
    />
</div>